import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Eyebrow } from '@/components/generals/section-heading'
import { TreeRings } from '@/components/generals/tree-rings'

interface PageHeaderProps {
    id?: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    children?: ReactNode
    className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({
    id = 'page-header',
    eyebrow,
    title,
    description,
    children,
    className
}): ReactNode => {
    return (
        <section id={id} className={cn('relative overflow-hidden border-b border-border/70', className)}>
            <TreeRings className='pointer-events-none absolute -top-40 -right-40 size-[34rem] text-timber/15 sm:-right-24' />

            <div className='relative mx-auto max-w-7xl px-5 pt-14 pb-16 sm:px-8 lg:pt-20 lg:pb-20'>
                <div className='max-w-3xl animate-in fade-in slide-in-from-bottom-3 duration-700 motion-reduce:animate-none'>
                    <Eyebrow>
                        {eyebrow}
                    </Eyebrow>

                    <h1 className='mt-5 font-heading text-[2.6rem] leading-[1.04] font-medium tracking-tight text-balance sm:text-5xl lg:text-6xl'>
                        {title}
                    </h1>

                    {description && (
                        <p className='mt-6 max-w-2xl text-lg leading-relaxed text-pretty text-muted-foreground'>
                            {description}
                        </p>
                    )}

                    {children}
                </div>
            </div>
        </section>
    )
}
